"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = void 0;
const typeorm_1 = require("typeorm");
const UserPermission_1 = require("./UserPermission");
const JournaledEntity_1 = require("../../JournaledEntity");
let UserRole = class UserRole extends JournaledEntity_1.JournaledEntity {
};
exports.UserRole = UserRole;
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], UserRole.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => UserPermission_1.UserPermission),
    (0, typeorm_1.JoinTable)(),
    __metadata("design:type", Array)
], UserRole.prototype, "permissions", void 0);
exports.UserRole = UserRole = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Unique)(['name'])
], UserRole);
